import SpecialtiesModel from '../DataModels/Menu';
import { actionManager } from './BaseFunction';
// ///////////////
// Reducers
// ///////////////
const specialtiesDM = new SpecialtiesModel();
const Specialties = (state = specialtiesDM, action) => actionManager(state, action, 'specialties');

export default Specialties;
